import { createSlice } from "@reduxjs/toolkit";

export const enrollmentStepGs1Slice = createSlice({
  name: "enrollmentStepGs1",
  initialState: {
    data: null, 
    error: null,
    isLoading: false
  },
  reducers: {
    startEnrollmentStepGs1: (state) => { state.isLoading = true; },
    setEnrollmentStepGs1: (state, { payload }) => {
      state.data = payload?.data ?? null;
      state.error = payload?.error ?? null;
      state.isLoading = false;
    }
  }
});

export const { startEnrollmentStepGs1, setEnrollmentStepGs1 } = enrollmentStepGs1Slice.actions;
